exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "._3U1Ms{margin-bottom:5px;display:block;color:red;font-size:14px;font-weight:400}._6dPv7{padding-left:0;list-style-type:none}._2xhVH{display:block;padding:6px 0;font-size:16px;color:#767676;text-decoration:none}._2xhVH:active,._2xhVH:hover{text-decoration:none;color:#484848}._2xhVH:active{font-weight:700}._1T5JD{border-radius:0;width:100%;display:block;color:#484848;font-size:16px;padding-bottom:12px;border-bottom:1px solid #dce0e0}a{text-decoration:none}a,a:hover{color:#008489}a:hover{cursor:pointer}.kwkSC{margin-top:12px}._3Xlpa{margin-bottom:24px}.U73Vb{border-color:#ff7e82;background-color:#ff7e82;color:#fff;font-size:14px;padding:9px 27px;width:100%}.U73Vb:hover{background:rgba(54,50,119,.8)}.U73Vb:focus{border-color:#0074c2;box-shadow:0 0 8px rgba(0,116,194,.6)}._3RgT6{border-color:#ff5a5f;background-color:#ff5a5f;color:#fff}._2O9Sx{padding:7px 21px}._3RgT6:active,._3RgT6:active:focus,._3RgT6:active:hover,._3RgT6:focus,._3RgT6:hover{border-color:#ff7e82;background-color:#ff7e82;color:#fff}._3O6Qa{border-color:#ff5a5f;color:#ff5a5f;background-color:#fff}._3O6Qa:active,._3O6Qa:active:focus,._3O6Qa:active:hover,._3O6Qa:focus,._3O6Qa:hover{border-color:#ff7e82;color:#ff7e82;background-color:#fff}.qxDrM{margin-bottom:12px}.sTtPr{display:block;padding:8px 10px;width:100%;font-size:14px;border-radius:2px;border:1px solid #aaa;background-color:#fff;color:#767676}._1QD9L{margin-bottom:12px}._2MI9W{float:right}._1JT0_{text-align:right}._2Rnf9{border-radius:2px;font-size:14px;width:100%;border:1px solid #aaa;background-color:#fff;color:#767676;display:block;overflow:hidden;-webkit-appearance:none;-moz-appearance:none;appearance:none}.yoQtU{margin-bottom:6px}.qxDrM{font-size:14px;color:#484848;font-weight:400}@media screen and (max-width:743px){._1JT0_{text-align:left}}", ""]);

// exports
exports.locals = {
	"errorMessage": "_3U1Ms",
	"listContainer": "_6dPv7",
	"sideNavitem": "_2xhVH",
	"panelHeader": "_1T5JD",
	"spaceTop2": "kwkSC",
	"space4": "_3Xlpa",
	"button": "U73Vb",
	"btnPrimary": "_3RgT6",
	"btnlarge": "_2O9Sx",
	"btnPrimaryBorder": "_3O6Qa",
	"labelText": "qxDrM",
	"formControlInput": "sTtPr",
	"formGroup": "yoQtU",
	"space2": "_1QD9L",
	"btnRight": "_2MI9W",
	"textRight": "_1JT0_",
	"formControlSelect": "_2Rnf9"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./~/postcss-loader?{"config":"./tools/postcss.config.js"}!./src/components/ForgotPassword/ChangePasswordForm/ChangePasswordForm.css
// module id = 2533
// module chunks = 15